module.exports = __webpack_public_path__ + "static/img/zengjia2.01b5401.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/zengjia2.png
// module id = IjJa
// module chunks = 24